/**
 * CityAndDatePresenter - Displays project location and date
 *
 * NOTE: This presenter component is separated from CityAndDate.tsx for Module Federation.
 * It contains the same UI logic but receives all data via props instead of MobX injection.
 * This allows JHP to consume it via Module Federation while Zoomin's CityAndDate.tsx
 * continues to use MobX stores for data. Both components should render identically.
 */

import * as React from 'react'

import { classList } from 'react-classlist-helper'

export interface IProjectAddress {
  city?: string
  state?: string
  country?: string
}

interface IProps {
  projectAddress: IProjectAddress
  date: string

  /** Whether it's constrained horizontally */
  compactH?: boolean
  /** Whether it's constrained vertically */
  compactV?: boolean
}

export default function CityAndDatePresenter({
  projectAddress,
  date,
  compactH,
  compactV,
}: IProps): JSX.Element | null {
  if (
    !projectAddress?.city ||
    !projectAddress?.state ||
    (compactH && compactV)
  ) {
    return null
  }

  return (
    <div
      className={classList({
        'x-end y-start': true,
        col: !compactH,
        row: compactH,
      })}
    >
      <div className="text large bold line-24">
        {`${projectAddress.city}, ${projectAddress.state}`}
      </div>
      <div className="text line-26">{date}</div>
    </div>
  )
}
